// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import {
  type AskPunttOpenItem,
  type ListAskPunttProjectOpenItemsResponse,
  type MarkAskPunttProjectDoneResponse,
} from "@mg/schemas/src/christo/askPunttOpenItems";

import { API_URL } from "../../config/env";
import { smartFetch } from "../../utils/http";

const BASE = `${API_URL}/private/catalyst/ask-puntt/projects`;

/** why: open item ids may contain ':' — encode path segments so gateways match the route. */
function openItemPathSegment(itemId: string): string {
  return encodeURIComponent(itemId);
}

export type MarkProjectDoneResult =
  | MarkAskPunttProjectDoneResponse
  | { done: false; openItems: AskPunttOpenItem[] };

export async function listProjectOpenItems(
  projectId: string,
): Promise<ListAskPunttProjectOpenItemsResponse> {
  const json = await smartFetch(`${BASE}/${projectId}/open-items`, {
    method: "GET",
  });
  return json as ListAskPunttProjectOpenItemsResponse;
}

export async function listOpenItemAssignees(projectId: string) {
  const json = await smartFetch(`${BASE}/${projectId}/open-items/assignees`, {
    method: "GET",
  });
  return json as { assignees: { userId: string; name: string }[] };
}

export async function assignOpenItem(
  projectId: string,
  itemId: string,
  ownerUserId: string,
): Promise<void> {
  await smartFetch(
    `${BASE}/${projectId}/open-items/${openItemPathSegment(itemId)}/assign`,
    {
      method: "POST",
      body: JSON.stringify({ ownerUserId }),
    },
  );
}

export async function nudgeOpenItem(
  projectId: string,
  itemId: string,
): Promise<void> {
  await smartFetch(
    `${BASE}/${projectId}/open-items/${openItemPathSegment(itemId)}/nudge`,
    {
      method: "POST",
    },
  );
}

export async function markProjectDone(
  projectId: string,
  override: boolean,
): Promise<MarkProjectDoneResult> {
  try {
    const json = await smartFetch(`${BASE}/${projectId}/mark-done`, {
      method: "POST",
      body: JSON.stringify({ override }),
    });
    return json as MarkAskPunttProjectDoneResponse;
  } catch (error) {
    if (error instanceof Response && error.status === 409) {
      const body = (await error.json()) as {
        done: false;
        openItems: AskPunttOpenItem[];
      };
      return body;
    }
    throw error;
  }
}
